import { useProductEditor } from '../product-editor-context'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Building2 } from 'lucide-react'

export function ManufacturerSection() {
  const { form } = useProductEditor()

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Building2 className="size-5 text-zinc-500" />
          <div>
            <CardTitle className="text-base">Manufacturer / Dropship</CardTitle>
            <CardDescription>Vendor information for order fulfillment</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <FormField
          control={form.control}
          name="manufacturer_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Manufacturer Name</FormLabel>
              <FormControl>
                <Input placeholder="Vendor name" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="grid sm:grid-cols-2 gap-4">
          <FormField
            control={form.control}
            name="manufacturer_email"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Manufacturer Email</FormLabel>
                <FormControl>
                  <Input type="email" placeholder="orders@vendor.com" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="manufacturer_order_url"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Order Portal URL</FormLabel>
                <FormControl>
                  <Input placeholder="https://..." {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          <FormField
            control={form.control}
            name="cost_price"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Your Cost ($)</FormLabel>
                <FormControl>
                  <Input
                    type="number"
                    step="0.01"
                    min="0"
                    placeholder="150.00"
                    {...field}
                    onChange={e => field.onChange(parseFloat(e.target.value) || undefined)}
                  />
                </FormControl>
                <FormDescription>For profit tracking</FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="estimated_ship_days"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Estimated Ship Days</FormLabel>
                <FormControl>
                  <Input
                    type="number"
                    min="1"
                    placeholder="5"
                    {...field}
                    onChange={e => field.onChange(parseInt(e.target.value) || 5)}
                  />
                </FormControl>
                <FormDescription>Days for vendor to ship</FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </CardContent>
    </Card>
  )
}
